import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { products } from '../data/products';
import BrandLogo from './BrandLogo';
const Footer = () => (
    <footer className="border-t border-blue-100 bg-gray-50 text-gray-600">
        <div className="mx-auto grid max-w-screen-2xl gap-10 px-6 py-12 sm:grid-cols-2 lg:grid-cols-4 lg:px-12">
            <div>
                <HashLink to="/#hero" className="mcn-brand-link"><BrandLogo /></HashLink>
                <p className="mt-4 leading-relaxed">Audio, video, and multimodal AI for content creation, healthcare, learning, and workforce development.</p>
            </div>
            <div>
                <h2 className="text-lg font-bold text-blue-900">Explore</h2>
                <ul className="mt-4 space-y-3">
                    <li><HashLink to="/#technology">Our technology</HashLink></li>
                    <li><HashLink to="/#services">Solutions</HashLink></li>
                    <li><HashLink to="/#portfolio">Products</HashLink></li>
                    <li><HashLink to="/get-demo#demo">Request a demo</HashLink></li>
                    <li><HashLink to="/contact#contact">Contact us</HashLink></li>
                    <li><HashLink to="/brand-assets">Brand assets</HashLink></li>
                </ul>
            </div>
            <div>
                <h2 className="text-lg font-bold text-blue-900">Products</h2>
                <ul className="mt-4 space-y-3">{products.map(product => <li key={product.id}><HashLink to={`/#product-${product.id}`}>{product.name}</HashLink></li>)}</ul>
            </div>
            <div>
                <h2 className="text-lg font-bold text-blue-900">Connect</h2>
                <ul className="mt-4 space-y-3">
                    <li><a href="mailto:contact@mcntech.com">contact@mcntech.com</a></li>
                    <li><a href="https://www.linkedin.com/company/mcntech" target="_blank" rel="noreferrer">LinkedIn</a></li>
                    <li><a href="https://www.facebook.com/people/MCN-Technologies/61565010812850/" target="_blank" rel="noreferrer">Facebook</a></li>
                </ul>
            </div>
        </div>
        <p className="border-t border-blue-100 px-6 py-6 text-center text-sm">© {new Date().getFullYear()} MCN Technologies. All rights reserved.</p>
    </footer>
);
export default Footer;
